/**
 * Created by Tom on 3/18/2017.
 */
import axios from 'axios'

axios.interceptors.request.use(
    async function (config) {
        config.url = AEAxiosUtils.getBaseUrl() + config.url
        config.withCredentials = true

        if (AEAxiosUtils.isRestRequest(config.url)) {
            if (AEAxiosUtils.isExpired(window.vueAuth.token)) {
                if (AEAxiosUtils.isExpired(window.vueAuth.refreshToken)) {
                    alert('Unable to refresh session, you must re-authenticate')

                    AEAxiosUtils.navigateToLogin()
                    throw new axios.Cancel('Operation cancelled do to expired/invalid credentials')
                }
                await AEAxiosUtils.refreshTokens()
            } else if (AEAxiosUtils.expiringWithin(window.vueAuth.token, 30)) {
                AEAxiosUtils.refreshTokens()
            }

            config.headers.common['Authorization'] = 'Bearer ' + window.vueAuth.token
        }

        return config
    }
)

axios.interceptors.response.use(
    function (response) {
        if (typeof response.data === 'string' && response.data.match(/<form (?!>).+action=('|")\/user\/login\/authenticate('|")/)) {
            AEAxiosUtils.navigateToLogin()
            return
        }

        return response
    }
)

class AEAxiosUtils {
    static decodeJwt (token) {
        const parts = token.split('.')

        try {
            return JSON.parse(atob(parts[1]))
        } catch (err) {
            return {}
        }
    }

    static isExpired (token) {
        return AEAxiosUtils.expiringWithin(token, 0)
    }

    static expiringWithin (token, nextSeconds) {
        if (typeof token === 'string') {
            token = AEAxiosUtils.decodeJwt(token)

            if (!Object.keys(token).length) {
                return true
            }
        }

        return (token.exp - nextSeconds) < (Date.now() / 1000)
    }

    static isRestRequest (url) {
        return url.match(/^http.*\/rest\/.*$/) !== null
    }

    static refreshTokens () {
        const authRefresh = axios.create()

        return authRefresh.post(
            AEAxiosUtils.getBaseUrl() + '/rest/authentication',
            {
                grantType: 'refresh',
                assertion: window.vueAuth.refreshToken
            }
        ).then(function (response) {
            window.vueAuth = response.data
        })
    }

    static navigateToLogin () {
        window.location.assign(AEAxiosUtils.getBaseUrl() + '/user/login')
    }

    static getBaseUrl () {
        return window.vueTarget ? window.vueTarget : 'http://kitt.local.it'
    }
}

export default axios
// Exported for testability
export { AEAxiosUtils }




// WEBPACK FOOTER //
// ./src/api/client.js